import { defineMessages } from 'react-intl';

export default defineMessages({
    backToSettings: {
        defaultMessage: 'Cancel',
        description: 'Action label for back button in layout builder screen',
        id: 'cv.portal.customization.action.cancel.help.center.settings',
    },
    publish: {
        defaultMessage: 'Publish layout',
        description: 'Label for publish button',
        id: 'cv.portal.customization.action.publish.layout.label',
    },
});
